export default "/images/vendor/flag-icon-css/flags/1x1/hk.svg?5a1122079f786b82c2ed4938e65caa7e";